/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const SortableItemTypes = Object.freeze({
    CONTENT: "content",
});
